<template>
	<div class="search-renewal-record">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					size="small"
					icon="el-icon-printer"
					hidden
					@click="exportOrder"
					>{{ $t("common.export") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="renewalRecord"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="dateTime">
						<el-date-picker
							v-model="dateTime"
							type="datetimerange"
							format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="-"
							:picker-options="pickerOptions"
							:start-placeholder="$t('searchOrder.start')"
							:end-placeholder="$t('searchOrder.end')"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item prop="userName">
						<el-input
							v-model="search.userName"
							:placeholder="$t('rechargeRecord.userName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="orderNumber">
						<el-input
							v-model="search.orderNumber"
							:placeholder="
								isRenewal
									? $t('renewalRecord.orderNumber')
									: $t('rechargeRecord.orderNumber')
							" @input="onSubmit"
						></el-input>
					</el-form-item>

					<el-form-item prop="state">
						<el-select
							v-model="search.state"
							:no-data-text="$t('common.noData')"
							:no-match-text="$t('common.noData')"
							clearable
							:placeholder="
								isRenewal
									? $t('searchRefundRecord.state')
									: $t('rechargeRecord.state')
							"
						>
							<el-option
								v-for="item in rentStateList"
								:key="item.id"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="payType">
						<el-select
							v-model="search.payType"
							:no-data-text="$t('common.noData')"
							:no-match-text="$t('common.noData')"
							clearable
							:placeholder="$t('searchRefundRecord.payType')"
						>
							<el-option
								v-for="item in payTypeList"
								:key="item.id"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('renewalRecord')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchRechargeRecord",
	props: {
		search: Object,
		payTypeList: Array,
		rentStateList: Array,
		isRenewal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			dateTime: "",
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},
	methods: {
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endTime = this.dateTime[1];
			} else {
				delete this.search.startTime;
				delete this.search.endTime;
			}
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.search);
			this.dateTime = "";
			this.$emit("resetSearch", this.search);
		},
		exportOrder() {
			this.$confirm(
				this.$t("searchRefundRecord.export"),
				this.$t("common.tip"),
				{
					confirmButtonText: this.$t("common.definite"),
					cancelButtonText: this.$t("common.cancel"),
					type: "warning",
				}
			)
				.then(() => {
					this.$api.download(this.$url.RenewalRecord.export, this.search);
				})
				.catch(err => {
					this.$message.error(err.msg);
				});
		},
	},
};
</script>

<style scoped></style>
